import {createAsyncThunk} from '@reduxjs/toolkit'

import {SHOPPING_MY_SUBSCRIPTION} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const navigateToShoppingMySubscriptionList = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam | void,
    ThunkApi
>('navigateTo/shoppingMySubscriptionList', async (args) => {
    const {forceLocationChange = false} = args ?? {}
    const url = SHOPPING_MY_SUBSCRIPTION

    if (forceLocationChange) {
        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
        return Promise.resolve()
    }

    openNewTab({url})
})

export default navigateToShoppingMySubscriptionList
